import * as constants from './../constants';
import {
    API_USER_SERVICE_PORT,
    CONTROL_CENTER_API_URL,
    HERMES_API,
} from '../../config/env/env';
import { filterArrayEmptyValue } from '../../utils/helper';
const mockServer = 'https://9e62366d-16e0-4f2b-9c8a-3ebd33d46448.mock.pstmn.io';
const mocking = false;
export const getLeadSourceList = (type, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/static-values/${type}`,
        method: 'GET',
        success: (data) => {
            return {
                type: constants.LEAD_SOURCE_STATIC_VALUES_DATA,
                payload: data.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const createStaff = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const createBDStaffAdmin = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/orgs/create/bd/admin',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const editBDStaffAdmin = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/orgs/create/bd/admin',
        method: 'PUT',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const editStaff = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/' + data.id,
        method: 'PUT',
        data: data.value,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const editStaffClient = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${data.id}/client-details`,
        method: 'PUT',
        data: data.value,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const fetchConvertStaffList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/lead/hire/getBulkConvert`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
/**export const covertToStaff = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/lead/hire/${id}/bulk-convert`,
        method: 'POST',
        data: {},
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});*/
export const covertToStaff = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/lead/hire/bulk-convert`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        async: true,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        hideNotify: true,
    },
});
export const fetchClientList = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/customers`,
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const fetchVendorList = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/vendors`,
        method: 'GET',
        success: (response) => {
            console.log('fetchVendorList', response);
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const editStaffVendor = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${data.id}/vendor-details`,
        method: 'PUT',
        data: data.value,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const deleteStaff = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/' + data.id,
        method: 'DELETE',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getSingleStaff = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/' + id,
        method: 'GET',
        data: {},
        success: (response) => {
            if (response && response.status && response.status.code == 200) {
                if (response.response) {
                    return {
                        type: constants.SET_SINGLE_STAFF_INFO,
                        payload: response.response,
                    };
                }
            }
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const UploadStaffInfo = (
    { uploadType, ...data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/org/transaction/${uploadType}/upload`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const UploadEarningsExternalClient = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/transaction/external-client/earning/upload`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const UploadSlot = ({ uploadType, ...data }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/slot/bulk/upload`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const UploadBulkHubs = (
    { uploadType, ...data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/org/hubs/bulk`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const UploadBulkBDVendors = (
    { uploadType, ...data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/org/vendor/bulk/bluedart`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const UploadBulkVendorsToHubs = (
    { uploadType, ...data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/org/hubs/bulk/map`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const UploadBulkEmpIDMapping = (
    { uploadType, ...data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/emp-id-mappings`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getAllStaffs = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/all',
        method: 'POST',
        data: data,
        success: setStaffData,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getV2AllStaffs = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/all/v2',
        method: 'POST',
        data: data,
        success: setStaffData,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getAllBlueDartStaffs = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/rider-onboarding/list',
        method: 'POST',
        data: data,
        success: setBlueDartStaffData,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllBlueDartCounts = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/rider-onboarding/counts',
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllBluedartHubs = (filters = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/hubs/all/bluedartstores',
        method: 'POST',
        data: filters,
        success: setHubList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllBluedartVendors = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/vendor/all/bluedart',
        method: 'GET',
        success: setBluedartVendorList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// Vendor list used by the Blue Dart rider filters. Kept separate from
// `getAllBluedartVendors` because this endpoint returns `{ orgId, vendorCode,
// name }` while the legacy one returns `vendorId` — the two shapes would
// clobber each other on the shared `vendors` slice.
export const getBluedartFilterVendors = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/vendors',
        method: 'GET',
        success: setBluedartFilterVendorList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

const setBluedartCities = (response) => ({
    type: constants.SET_BLUEDART_CITIES,
    payload: response?.response?.data,
});

const setBluedartZones = (response) => ({
    type: constants.SET_BLUEDART_ZONES,
    payload: response?.response?.data,
});

export const getAllBluedartServiceCentreCities = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/service-centre/cities',
        method: 'GET',
        success: setBluedartCities,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getAllBluedartServiceCentreZones = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/service-centre/zones',
        method: 'GET',
        success: setBluedartZones,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getBlueDartServiceCentres = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/service-centre/all',
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getBlueDartRollCodes = (staffTypeId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/role-types/${staffTypeId}`,
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getEducationalQualifications = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/educational-qualifications',
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getBdUniformSizeOptions = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/uniform-size-options',
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getV2AllStaffCounts = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/all/count/v2',
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getAllOrders = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/orders`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});
export const getAllRiders = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/riders`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});
export const getAllAlerts = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/alerts`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});
export const updateAlerts = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/alert/${data.id}`,
        method: 'PUT',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});
export const getAlertsHistory = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/alert/${data.id}/history`,
        method: 'GET',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});

export const getPingsRider = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/riders/ping_rejection_history`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});
export const getPingsRiderFromMeta = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `https://bis.loadshare.net/public/question/7cc47bde-cdf4-441f-a514-a8230bd6a8bc/?start_date=${data?.startDate}&end_date=${data?.endDate}&field_executive_id=${data?.riderId}`,
        method: 'GET',
        data: {},
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});
export const getCompletedOrdersRider = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/riders/completed_orders`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});

export const getEventsForOrder = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/order/${data?.orderId}/events`,
        method: 'GET',
        data: {},
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});

export const getEventsRider = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/riders/events`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});

export const getMissedOrdersRider = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/riders/missed_orders`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});

export const getCancelledOrdersRider = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `${
            !!mocking ? mockServer : CONTROL_CENTER_API_URL
        }/control_center/v1/riders/cancelled_orders`,
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: true,
    },
});

export const getAllStaffsReport = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/all/report',
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getV2AllStaffsReport = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/all/report/v2',
        method: 'POST',
        data: data,
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getHubList = (orgId, onSuccess, onError, hideNotify = false) => ({
    type: constants.API,
    payload: {
        // url: '/org/hubs/list/all',
        url: `/org/hubs/list/${orgId}/all`,
        method: 'GET',
        success: setHubList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        hideNotify,
    },
});
export const getHubListWithFilters = (orgId, filters, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        // url: '/org/hubs/list/all',
        url: `/org/hubs/list/${orgId}/all/v2`,
        method: 'POST',
        data: filters,
        success: setHubList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getClusterList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/clusters/fetch`,
        method: 'POST',
        data: data,
        success: setClusterList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        thirdParty: false,
    },
});

export const getShiftTimingsList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/shift/filter',
        method: 'POST',
        data,
        success: setShiftTimingsList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getStaffTypeList = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/types',
        method: 'GET',
        success: setStaffTypeList,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getBaseRateTypeList = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/base-rate-types',
        method: 'GET',
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getSalaryTypeList = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/salary-types',
        method: 'GET',
        success: () => {
            return { type: constants.DO_NOTHING };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const resetKycDetails = () => {
    return { type: constants.SET_KYC_STAFF_INFO, payload: {} };
};

export const getKycDetails = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/kyc`,
        method: 'GET',
        success: setKycDetails,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

/**
 * Admin view of a staff member's MPIN state (drives the Reset MPIN modal):
 * { status: ACTIVE|EXPIRED|SETUP_REQUIRED, expiresAt, resetRequested,
 *   resetRequestedAt }. `userId` is the staff row id.
 */
export const getMpinSummary = (userId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/user/${userId}/mpin/summary`,
        method: 'GET',
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

/**
 * Vendor/OPS expires a staff member's MPIN. The backend only permits this
 * while the rider has a pending reset request — the modal mirrors that
 * gate in the UI, but the server check is the real one.
 */
export const expireMpin = (userId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/user/${userId}/mpin/expire`,
        method: 'POST',
        data: {},
        success: () => ({ type: constants.DO_NOTHING }),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getEvDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${data?.id}/ev/details`,
        method: 'POST',
        success: setEvDetails,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});

export const updateEvStatus = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/update/ev-request`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});
export const captainApprove = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/ev/captain/approve`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});
export const vendorUpdate = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/update/vendor`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});

export const getStaffEvHistory = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/ev/history`,
        method: 'POST',
        success: setStaffEvHistory,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});
const setStaffEvHistory = (data) => {
    if (data && data.response) {
        return {
            type: constants.SET_ALL_STAFF_EV_HISTORY,
            payload: data.response,
        };
    }
};

export const staffKycApproveReject = (
    { staffId, data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/kyc/status`,
        method: 'PUT',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getStaffBankDetails = ({ staffId, data }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/bank-details`,
        method: 'GET',
        port: API_USER_SERVICE_PORT,
        data,
        success: (response) => updateStaffBankData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const postKycDetails = ({ staffId, data }, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/kyc`,
        method: 'POST',
        port: API_USER_SERVICE_PORT,
        data,
        success: (response) => updateStaffBankData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const updateFatherName = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/de/user/kyc/father-name',
        method: 'PUT',
        port: API_USER_SERVICE_PORT,
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const postStaffBankDetails = (
    { staffId, data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/bank-details`,
        method: 'POST',
        port: API_USER_SERVICE_PORT,
        data,
        success: (response) => updateStaffBankData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

// payslip apis
export const fetchAllPayslip = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/payslips`,
        method: 'POST',
        success: setStaffPayslip,
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});
export const generatePayslip = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/payslip/generate`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});
export const savePayslip = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/payslip`,
        method: 'POST',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});
export const autoSignPayslip = (id, payslipId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/payslip/${payslipId}/sign`,
        method: 'PUT',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const approvePayslip = (
    id,
    { payslipId, ...data },
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/payslip/${payslipId}/approve`,
        method: 'PUT',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
        data,
    },
});
export const deletePayslip = (id, payslipId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${id}/payslip/${payslipId}`,
        method: 'DELETE',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

const updateStaffBankData = (data, loginFromWeb) => {
    let staffInfo = {
        bankDetails: {},
    };

    // Response to have status 200 for all success cases
    if (data && data.status && data.status.code === 200) {
        if (data && data.response) {
            staffInfo.bankDetails = {
                ...data.response,
            };
        }
    }
    return { type: constants.UPDATE_STAFF_BANK_DETAILS, payload: staffInfo };
};

const setStaffData = (data) => {
    if (data && data.response) {
        return { type: constants.SET_ALL_STAFF_INFO, payload: data.response };
    }
};
const setBlueDartStaffData = (data) => {
    if (data && data.response) {
        return {
            type: constants.SET_ALL_BLUE_DART_STAFF_INFO,
            payload: data.response,
        };
    }
};
const setStaffPayslip = (data) => {
    if (data && data.response) {
        return {
            type: constants.SET_ALL_STAFF_PAYSLIP,
            payload: data.response,
        };
    }
};
const setHubList = (data) => {
    if (data && data.response) {
        const { totalCount, ...payload } = data.response;
        return { type: constants.SET_HUB_LIST, payload };
    }
};
const setClusterList = (data) => {
    if (data && data.response) {
        const { totalCount, lineItems, ...payload } = data.response;
        return { type: constants.SET_CLUSTER_LIST, payload: lineItems };
    }
};
const setShiftTimingsList = (data) => {
    if (data && data.response) {
        return {
            type: constants.SET_SHIFT_TIMINGS_LIST,
            payload: data.response,
        };
    }
};
const setBluedartVendorList = (data) => {
    if (data && data.response) {
        return {
            type: constants.SET_BLUEDART_VENDOR_LIST,
            payload: { vendors: data.response.vendors ?? [] },
        };
    }
};
const setBluedartFilterVendorList = (data) => {
    if (data && data.response) {
        return {
            type: constants.SET_BLUEDART_FILTER_VENDOR_LIST,
            payload: data.response.vendors ?? [],
        };
    }
};
const setStaffTypeList = (data) => {
    if (data && data.response) {
        return { type: constants.SET_STAFF_TYPE_LIST, payload: data.response };
    }
};
const setKycDetails = (data) => {
    if (data && data.response) {
        return { type: constants.SET_KYC_STAFF_INFO, payload: data.response };
    }
};

const setEvDetails = (data) => {
    if (data && data.response) {
        let response = data?.response ?? {};
        if (
            !!response?.evDetails &&
            response?.evDetails?.evDocuments &&
            response?.evDetails?.evDocuments?.evOthers
        ) {
            // let parsed = JSON.parse(
            //     response?.evDetails?.evDocuments?.evOthers ?? '',
            // );
            let parsed = !!response?.evDetails?.evDocuments?.evOthers
                ? filterArrayEmptyValue(
                      response?.evDetails?.evDocuments?.evOthers
                          .replace(/\[|\]/g, '')
                          .trim()
                          .split(', '),
                  )
                : [];
            response.evDetails = {
                ...response.evDetails,
                evDocuments: {
                    ...response.evDetails.evDocuments,
                    evOthers: !!parsed ? parsed : [],
                },
            };
        }
        if (
            !!response?.evDetails &&
            response?.evDetails?.untagEvDocuments &&
            response?.evDetails?.untagEvDocuments?.evOthers
        ) {
            let parsed = !!response?.evDetails?.untagEvDocuments?.evOthers
                ? filterArrayEmptyValue(
                      response?.evDetails?.untagEvDocuments?.evOthers
                          .replace(/\[|\]/g, '')
                          .trim()
                          .split(', '),
                  )
                : [];
            console.log('the parsed', parsed);

            response.evDetails = {
                ...response.evDetails,
                untagEvDocuments: {
                    ...response.evDetails.untagEvDocuments,
                    evOthers: !!parsed ? parsed : [],
                },
            };
        }
        return { type: constants.SET_STAFF_EV_INFO, payload: data.response };
    }
};

export const sendAppLink = (staffId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/send-onboarding-sms`,
        method: 'PUT',
        port: API_USER_SERVICE_PORT,
        staffId,
        success: (response) => {
            console.log('Response from API', response);
            return { type: constants.DO_NOTHING, payload: response.response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const getRateCard = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/rate-card`,
        method: 'POST',
        port: API_USER_SERVICE_PORT,
        data,
        success: (response) => {
            console.log('Response from API', response);
            return {
                type: constants.SET_RATE_CARD,
                payload: response.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const updateStatus = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${data.staffId}/update-status`,
        method: 'PUT',
        port: API_USER_SERVICE_PORT,
        data: { status: data.status },
        success: (response) => {
            console.log('Response from update-status', response);
            return {
                type: constants.DO_NOTHING,
                payload: response.response,
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const BulkUploadStaffs = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/user/upload/staff`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getStaffCityZones = (cityId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/${cityId}/zones`,
        method: 'GET',
        success: (response) => {
            console.log('GetCityZones', response.response);
            return {
                type: constants.SET_STAFF_CITY_ZONES,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const getchZoneList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/common/zones`,
        method: 'POST',
        data,
        success: (response) => {
            console.log('GetchZoneList', response.response);
            return {
                type: constants.SET_STAFF_CITY_ZONES,
                payload: response?.response ?? {},
            };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
export const initiateDlVerification = (staffId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/dl/verification/existing/user',
        method: 'POST',
        data: { userId: [staffId] },
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const initiatePanVerification = (staffId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/dl/verification/existing/user',
        method: 'POST',
        data: { userId: [staffId] },
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const triggerBGVManual = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/org/staff/bgv/manual/trigger',
        method: 'POST',
        data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const confirmAddressVerification = (staffId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/org/staff/${staffId}/confirm-address`,
        method: 'POST',
        data: {},
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// ---------------------------------------------------------------- BD User Management (PRD UM-1..UM-9)
// Listing is POST because it carries filters and paging in a body — the backend deliberately avoids
// the GET-with-@RequestBody shape the legacy admin listing uses, which most clients cannot send.

export const getBluedartInternalUsers = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/internal-users/list',
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const createBluedartInternalUser = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/internal-users',
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const updateBluedartInternalUserScope = (
    userId,
    data = {},
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/internal-users/${userId}/scope`,
        method: 'PUT',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const deactivateBluedartInternalUser = (userId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/internal-users/${userId}/deactivate`,
        method: 'PUT',
        data: {},
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// Returns only what the caller may grant — a Regional Approver gets their own zones and the stores
// inside them, never the full master (RB-3 / RB-12).
export const getBluedartScopeOptions = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/internal-users/scope-options',
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// ---------------------------------------------------------------- BD Approval Workflow (PRD AP-1..AP-10)

export const getBluedartApprovalFilterOptions = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/approval-requests/filter-options',
        method: 'GET',
        hideNotify: true,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getBluedartApprovalRequests = (data = {}, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/approval-requests/list',
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const getBluedartApprovalRequest = (requestRef, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/approval-requests/${requestRef}`,
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const approveBluedartRequest = (
    requestRef,
    data = {},
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/approval-requests/${requestRef}/approve`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const rejectBluedartRequest = (
    requestRef,
    data = {},
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/approval-requests/${requestRef}/reject`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// The hub is derived from the request server-side, so only the search term is sent.
export const getBluedartReplacementCandidates = (
    requestRef,
    search,
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/approval-requests/${requestRef}/replacement-candidates?search=${encodeURIComponent(search ?? '')}`,
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// ---------------------------------------------------------------- BD Deactivation (PRD DR-1..DR-7)

export const getBluedartDeactivationReasons = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        url: '/bluedart/riders/deactivation-reasons',
        method: 'GET',
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

// Raises a request; the rider's status does not change until it is approved.
export const raiseBluedartDeactivation = (
    riderUserId,
    data = {},
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/riders/${riderUserId}/deactivation-request`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});

export const raiseBluedartReactivation = (
    riderUserId,
    data = {},
    onSuccess,
    onError,
) => ({
    type: constants.API,
    payload: {
        url: `/bluedart/riders/${riderUserId}/reactivation-request`,
        method: 'POST',
        data: data,
        success: (response) => {
            return { type: constants.DO_NOTHING, payload: response };
        },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
        port: API_USER_SERVICE_PORT,
    },
});
